import { formatDateFull } from '~/lib/DateTime';
import useCurrentBusiness from '~/lib/useCurrentBusiness';
import ClientPicker from '~/components/ClientPicker';
import { useInvoiceContext } from '~/lib/InvoiceContext';
import WarningTriangleIcon from '~/components/icons/WarningTriangleIcon.jsx';
import InlineEditableItemContainer from '~/components/forms/questions/components/InlineEditableItemContainer';

const BillingInfoQuestion = ({ label, value, setValue, settings }) => {
    const invoiceContext = useInvoiceContext();

    // Get invoice and client from context
    const invoice = invoiceContext?.invoice;
    const contextClient = invoiceContext?.client;

    // Get settings with defaults
    // Use invoice_number from invoice model, fallback to settings, then invoice ID, then 'TBD'
    const invoiceNumber = invoice?.invoice_number || settings?.invoiceNumber || invoice?.id || 'TBD';
    const issueDate = settings?.issueDate || invoice?.created_at || new Date().toISOString();
    const dueDate = invoice?.due_at || settings?.dueDate || calculateDefaultDueDate(issueDate);
    const notes = settings?.notes || '';

    // Get client from context or invoice
    const client = contextClient || invoice?.client || null;

    function calculateDefaultDueDate(issueDateStr) {
        const date = new Date(issueDateStr);
        date.setDate(date.getDate());
        return date.toISOString();
    }

    // View mode - display information
    return (
        <div className="space-y-4">
            <div className="grid md:grid-cols-[2fr_1fr_1fr] gap-6">
                <div>
                    <div className="font-medium mb-2">Bill To</div>
                    <InlineEditableItemContainer>
                        {!!client && (
                            <>
                                <div className="text-gray-600">
                                    {client.first_name || client.firstName} {client.last_name || client.lastName}
                                </div>
                                <div className="text-gray-500">
                                    {client.email}
                                </div>
                                {client.phone && !String(client.phone).includes('undefined') && (
                                    <div className="text-gray-500">{client.phone}</div>
                                )}
                            </>
                        )}
                        {!client?.email && (
                            <div className="text-red-600 font-medium flex gap-3 items-center">
                                <WarningTriangleIcon className="w-5 h-5 flex-shrink-0" />
                                Add Client
                            </div>
                        )}
                    </InlineEditableItemContainer>
                    {!!notes && (
                        <InlineEditableItemContainer className="mt-2 whitespace-pre-line">
                            {notes}
                        </InlineEditableItemContainer>
                    )}
                </div>
                <InlineEditableItemContainer label="Issue Date">
                    {formatDateFull(issueDate)}
                </InlineEditableItemContainer>

                <InlineEditableItemContainer label="Due Date">
                    {formatDateFull(dueDate)}
                </InlineEditableItemContainer>
            </div>
        </div>
    );
};

export default BillingInfoQuestion;

